export const allCountries = [
  {
    name: 'תאילנד',
    countryCode: 'TH',
    slug: 'thailand',
    active: true,
  },
  {
    name: 'וייטנאם',
    countryCode: 'VN',
    slug: 'vietnam',
    active: true,
  },
  {
    name: 'קמבודיה',
    countryCode: 'KH',
    slug: 'cambodia',
    active: true,
  },
  {
    name: 'לאוס',
    countryCode: 'LA',
    slug: 'laos',
    active: false,
  },
  {
    name: 'פיליפינים',
    countryCode: 'PH',
    slug: 'philippines',
    active: false,
  },
  {
    name: 'יפן',
    countryCode: 'JP',
    slug: 'japan',
    active: false,
  },
];
